export const ja = {
  translation: {
    nav: {
      title: '禅ライフ鍼灸院', // Add a title for the Navbar componen
      home: 'ホーム',
      services: 'サービス',
      about: '私たちについて',
      contact: 'お問い合わせ',
      gallery: 'ギャラリー',
      appointment: '予約',
      herbtea: 'ハーブティー',
      telemedicine: "遠隔医療",
      store: "ストア"
    },
    home: {
      welcome: '禅ライフ鍼灸院へようこそ',
      "subtitle": "伝統と革新、癒しと心を込めて",
      "description1": '現代医学と伝統的な中医学の完璧な融合によって、鍼灸の独自な効果を体験してください',
      "description2": '私たちは三代にわたる伝統の知識を受け継ぎ、現代医学の理念を取り入れ、患者様一人ひとりに専門的で個別化された治療を提供しています。',
      "description3": '当院の鍼灸師は、伝統的な鍼灸、カッピング、グアシャ、中薬に精通しているだけでなく、独自に開発した鍼灸技術を用いて、顔面神経麻痺、椎間板ヘルニア、坐骨神経痛、頚椎の圧迫による痛みなど、さまざまな難治症状を改善してきました。',
      "description4": 'ここでは、伝統中医学の深い知識と現代医学の先端的なアプローチが出会い、健康と活力の回復をサポートいたします。',
      subtitleinsurance: 'あなたの保険が鍼灸をカバーしているか知りたいですか？',
      insuranceprompt: '質問を408-922-6848にテキストメッセージで送るか、zenlifeacu@gmail.comまでメールしてください。お名前、電話番号、生年月日、保険証の表裏の写真をお送りください。',
      contactButton: 'お問い合わせ',
      bookButton: '予約する',
      promotions: 'プロモーションとお知らせ',
      videoTitle: "ミステリーハーブティーブラインドボックス",
      videoDescription: "毎週日曜日、無料の特製漢方茶ドリンクを提供しています。当日限定の試飲です"
    },
    services: {
      title: 'サービス内容',
      acupuncture: {
        title: '鍼灸',
        description: '肩こり、頭痛、坐骨神経痛、アレルギー、しわ改善、減量、不眠症などの治療。'
      },
      electroacupuncture: {
        title: '電気鍼治療',
        description: '慢性痛, 神経系疾患, スポーツ傷害の回復, 感情的な問題, 消化器系の問題, 婦人科の問題'
      },
      cupping: {
        title: 'カッピング',
        description: '痛み緩和、湿邪排出、坐骨神経痛治療、デトックスなど。'
      },
      guaSha: {
        title: 'グアシャ',
        description: '生理痛、腰痛、膝の痛み、免疫システムの改善。'
      },
      manualTherapy: {
        title: 'マニュアルセラピー',
        description: '痛みを和らげ、治癒を促進するハンドセラピー。'
      },
      infraLight: {
        title: '赤外線療法',
        description: '治癒促進と痛み緩和のための先進的な光療法。'
      },
      herbs: {
        title: '漢方薬',
        description: '個々のニーズに合わせた伝統的な漢方薬。'
      }
    },
    contact: {
      title: 'お問い合わせ',
      direction: 'アクセス',
      address: {
        title: '住所',
        value: '8 N Abel St, Milpitas, CA 95035'
      },
      phone: {
        title: '電話',
        regularHours: '営業時間内: 408-922-6848',
        afterHours: '営業時間外: 408-465-4289'
      },
      email: {
        title: 'メール',
        value: 'zenlifeacu@gmail.com'
      },
      payment: {
        title: 'お支払い方法',
        description: '主要なPPO保険、クレジットカード、HSA、PayPal、Venmoをご利用いただけます'
      },
      findUs: 'I-880とI-680の両方からアクセス便利なミルピタスの中心部に位置しています。',
      specializedClaims: "専門的な保険請求",
      carAccidentClaims: "自動車事故保険の請求を受け付けており、必要な治療文書を提供するために自動車保険会社と直接連携しています。",
      workersCompClaims: "職場での怪我に対する労災補償請求を処理し、患者の回復と職場復帰をサポートします。",
      legalReferrals: "人身傷害や労災補償事件を専門とする法律事務所からの患者紹介を歓迎します。"
    },
    // Add to existing ja.js translation object
    footer: {
      title: '禅ライフ鍼灸院',
      address: '8 N Abel St\nMilpitas, CA 95035',
      contact: {
        title: 'お問い合わせ',
        phone: '電話：408-922-6848',
        email: 'メール：zenlifeacu@gmail.com'
      },
      social: {
        title: 'ソーシャルメディア',
        wechat: 'WeChat：ZenLifeAcupuncture',
        rednote: 'RedNote：ZenLifeAcu'
      },
      copyright: '禅ライフ鍼灸院。全著作権所有。'
    },
    // ... existing code ...
    telemedicine: {
      title: "遠隔医療サービス",
      subtitle: "ご自宅から経験豊富な鍼灸師とのオンライン相談",
      benefitsTitle: "遠隔医療サービスのメリット",
      //payWithPayPal: "Pay with PayPal", // English
      // payWithPayPal: "Pagar con PayPal", // Spanish
      payWithPayPal: "PayPalで支払う", // Japanese
      // payWithPayPal: "Thanh toán bằng PayPal", // Vietnamese
      // payWithPayPal: "使用PayPal付款", // Chinese
      benefits: {
        benefit1: "自宅を離れることなく、専門的な中医学相談に便利にアクセス",
        benefit2: "あなたの特定の健康ニーズに基づいたパーソナライズされた漢方処方",
        benefit3: "詳細な健康評価とカスタマイズされた治療計画",
        benefit4: "必要に応じたフォローアップケアと治療の調整",
        benefit5: "専門家のケアを受けながら、時間を節約し移動を避ける",
        benefit6: "伝統的な中医学と漢方薬に関する私たちの豊富な知識へのアクセス"
      },
      processTitle: "遠隔医療サービスの流れ",
      process: {
        step1: {
          title: "1. お支払い",
          description: "以下のPayPalボタンを使用して、30分間の遠隔医療相談の支払いを行います。"
        },
        step2: {
          title: "2. 予約を取る",
          description: "支払い後、注文番号を使用してオンラインで予約をします。医療履歴や関連する検査結果をアップロードすることができます。"
        },
        step3: {
          title: "3. オンライン相談",
          description: "Zoomを通じて当院の鍼灸師と会い、あなたの健康状態について話し合います。総合的な評価、必要に応じた漢方処方、健康アドバイスを提供します。"
        },
        step4: {
          title: "4. 漢方薬の支払い（必要な場合）",
          description: "漢方薬が推奨される場合、薬草と配送料の請求書をお送りします。オンラインで支払いができます。"
        },
        step5: {
          title: "5. 漢方薬の受け取り",
          description: "あなたのためにカスタマイズされた漢方処方をご自宅に直接準備して発送します。"
        }
      },
      paymentTitle: "遠隔医療相談の予約",
      consultationFee: "30分間の相談：$50",
      afterPayment: "支払い後、注文番号が記載された確認メールが届きます。この番号を使用して予約をしてください。",
      scheduleButton: "予約する",
      herbsTitle: "当院の漢方薬について",
      herbsDescription: "当院の漢方処方は、あなたの特定の健康ニーズに合わせてカスタマイズされています。純度と効能がテストされた高品質の本物の中国ハーブのみを使用しています。",
      shippingInfo: "漢方薬のコストと配送料は、処方箋とあなたの場所によって異なります。あなたのニーズと予算に合わせて様々な配送方法を提供しています。"
    },
    store: {
      title: "Zen Life オンラインストア",
      subtitle: "伝統的な漢方製品",
      description: "高品質な伝統漢方製品を取り揃えています。全国配送可能です。",
      buyNow: "今すぐ購入",
      products: [
        {
          name: "100%天然ハイドラかゆみ止めクリーム",
          price: "$39.99",
          description: "湿疹やアトピー性皮膚炎によるかゆみや乾燥したフケ状の皮膚を和らげます。外用のみ。",
          image: "/images/products/product1.jpg",
          paypalLink: "https://www.paypal.com/ncp/payment/USDMG75T3T7CW"
        },
        {
          name: "健康調整のための多種類のハーブティー",
          price: "$80",
          description: "様々な健康状態に合わせて特別に調合されたハンドクラフトのハーブブレンド。各プレミアムパックは、1日分の治療用お茶を提供し、最大1ガロンの水で最大限の効果を発揮します。厳選されたハーブが一日中自然なウェルネスサポートを提供します。",
          image: "/images/products/product2.jpg",
          paypalLink: "https://www.paypal.com/ncp/payment/FGWQPWEAVZ9AL"
        }
        // More products can be added here later
      ]
    },
    // ... existing code ...
    herbtea: {
      title: "🌿 中国漢方茶 · ベイエリアのエンジニア向け特別調合 🌿",
      subtitle: "☕ 忙しい時でも健康を — あなたの心身の健康を私たちが守ります！",
      description: "純粋な天然の中国ハーブと伝統的な中国医学理論に基づき、ベイエリアのエンジニアに適したさまざまな健康茶を慎重に調合しています。異なる体質やニーズに応じて、あなたに合った茶療法コースを柔軟に選択できます：",
      benefits: [
        "✔ 科学的に配合された用量、薬を煎じる必要なし",
        "✔ ティーバッグですぐに淹れられる、シンプルで便利",
        "✔ 1コースは3週間、週に3杯だけ",
        "✔ 無料試飲のためにお店へのご来店歓迎！"
      ],
      benefits1: "効果",
      ingredients: "成分",
      customService: {
        title: "🧑‍⚕️ パーソナライズされたカスタムサービス · あなたの体に合わせて",
        description: "私たちは、あなたのためのパーソナライズされた健康プランを作成するために、1対1の中医学体質分析とカスタム茶サービスを提供しています：",
        options: [
          {
            name: "健康維持パーソナライズド茶",
            details: "相談 + 1コースの健康茶",
            price: "わずか $80"
          },
          {
            name: "治療用中国医学サービス",
            details: "相談 + 1コースの濃縮中国医学煎じ薬（特定の症状治療用）",
            price: "$200"
          }
        ]
      },
      popularTeas: {
        title: "🍵 おすすめの人気健康茶5種",
        teas: [
          {
            id: 1,
            name: "スイカズラ茶",
            ingredients: "アストラガルス、スイカズラ、モクレン花、菊花",
            benefits: "免疫力を高め、鼻の敏感さや花粉アレルギーを和らげます"
          },
          {
            id: 2,
            name: "心を養い落ち着かせる飲み物",
            ingredients: "サルビア、ユリの球根、酸棗仁、ショウブ",
            benefits: "睡眠の質を改善し、心を落ち着かせます"
          },
          {
            id: 3,
            name: "人参茯苓白朮飲",
            ingredients: "陳皮、白朮、茯苓、ハトムギ、金銭草、仏手柑",
            benefits: "脾を強化し、湿気を取り除き、消化器系を調整します"
          },
          {
            id: 4,
            name: "心を落ち着かせ知性を高める茶",
            ingredients: "益智仁、クコの実、サルビア、ショウブ",
            benefits: "脳循環を改善し、心をリフレッシュします"
          },
          {
            id: 5,
            name: "美容栄養茶",
            ingredients: "アストラガルス、サルビア、当帰、クコの実、バラの花",
            benefits: "気と血を補充し、肌を美しくします"
          }
        ]
      },
      pricing: {
        title: "💰 価格メリット · 柔軟なオプション",
        options: [
          "3杯トライアルパック：$15",
          "6杯ベーシックパック：$26",
          "9杯コースパック：$40",
          "健康維持カスタム（相談 + 茶）：$80",
          "治療用濃縮中国医学（相談 + 煎じ薬）：$200"
        ],
        promotion: "🎁 無料試飲のためにお店を訪れ、あなたのパーソナライズされた健康の旅を始めましょう！"
      }
    }
  },
  electroAcupunture:
  {
    "header": "電気鍼治療とその利点",
    "section1_title": "電気鍼治療の基本概念",
    "section1_text": "電気鍼治療は、伝統的な鍼治療と現代の電気療法を組み合わせた治療法です。鍼を体の特定のポイントに挿入した後、微弱な電流を流して刺激を与えます。痛みの管理、神経系の疾患、筋肉や関節の問題の治療、そして全体的な健康改善に広く利用されています。",

    "section2_title": "電気鍼治療の主な利点",
    "benefit1": "痛みの緩和：電気鍼治療は神経系を刺激し、痛みの信号伝達を調整して、慢性的な痛みや急性の痛みを緩和します。関節炎、頭痛、肩こりなどの治療に有効です。",
    "benefit2": "血液循環の改善：電流刺激は局所的な血液循環を促進し、組織への酸素や栄養供給を助け、代謝を促進し、炎症を軽減します。",
    "benefit3": "神経系の調整：電気鍼は自律神経系を刺激し、体内の神経活動を調整します。不安や不眠を軽減し、免疫機能を強化します。",
    "benefit4": "筋肉のけいれんの緩和とリラックス：電流は筋肉の緊張を効果的に緩和し、筋肉の柔軟性を改善し、けいれんや硬直を緩和します。",
    "benefit5": "組織の修復と回復の促進：電気鍼は受傷した組織の修復を加速し、細胞再生を促進し、スポーツ損傷後のリハビリテーションに使用されます。",
    "benefit6": "免疫力の強化：電気鍼は免疫反応を調整し、体の感染に対する抵抗力を高め、慢性疾患や自己免疫疾患の治療に有益です。",

    "section3_title": "電気鍼治療の適応症",
    "indication1": "慢性痛（関節炎、背中の痛み、首の痛みなど）",
    "indication2": "神経系の疾患（脳卒中後のリハビリ、顔面麻痺など）",
    "indication3": "スポーツ損傷の回復（筋肉のひねり、靭帯損傷など）",
    "indication4": "感情的な問題（不眠、不安など）",
    "indication5": "消化器系の問題（便秘、下痢など）",
    "indication6": "婦人科の問題（月経不順、月経痛など）",

    "section4_title": "電気鍼治療の注意事項",
    "precaution1": "治療前の相談：電気鍼治療はすべての人に適しているわけではなく、特に心臓病、皮膚疾患、妊娠中の方などには適さない場合があります。使用前に専門の鍼灸師に相談してください。",
    "precaution2": "治療中の感覚：治療中に軽い刺すような感覚や電流の感覚を感じることがありますが、これは正常な反応です。不快感がある場合は、電流の強度を調整するために医師に知らせてください。",
    "precaution3": "過剰使用を避ける：電気鍼治療は効果的ですが、頻繁に使用したり、強度が強すぎたりすると皮膚や組織に悪影響を与える可能性があります。"
  }
};